import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BrandLoadingAnimationComponent } from 'app/components/distinct-components/animations/brand-loading-animation/brand-loading-animation.component';
import { AppStateService } from 'app/services/app-state.service';
import anime from 'animejs/lib/anime.es.js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-initialize',
  standalone: true,
  imports: [CommonModule, BrandLoadingAnimationComponent],
  templateUrl: './initialize.component.html',
  styleUrl: './initialize.component.scss'
})
export class InitializeComponent {
  showBrandAnimation: boolean = false;
  initializationText: string = null;

  constructor(private appState: AppStateService, private router: Router) { }

  ngOnInit() {
    this.handleStateReset();
    this.animateView();
    setTimeout(() => {
      this.animateText();
    }, 1000);
  }

  handleStateReset(): void {
    this.appState.resetAgentState();
  }

  animateView(): void {
    anime({
      targets: '#left-panel',
      opacity: [1, 0],
      easing: 'easeOutQuad',
      duration: 800,
      loop: false
    });
    anime({
      targets: '#right-panel',
      width: ['49%',  '0%'],
      easing: 'easeOutQuad',
      duration: 450,
      loop: false
    });

    setTimeout(() => {
      this.animateBrand();
    }, 500);
    
  }

  animateBrand(): void {
    this.showBrandAnimation = true;
  }

  animateText(): void {
    this.typeOutText('Initializing Account and Agent Settings...');

    setTimeout(() => {
      this.typeOutText('Checking for recent Agent Conversations & Tasks...');
    }, 3000);
  }

  onBrandAnimationComplete():void {
    this.router.navigateByUrl('/agent');
  }

  typeOutText(fullText: string, speed: number = 20): void {
    this.initializationText = ' '; // reset before typing
    let index = 0;
  
    const interval = setInterval(() => {
      this.initializationText += fullText.charAt(index);
      index++;
  
      if (index >= fullText.length) {
        clearInterval(interval);
      }
    }, speed);
  }


}
